import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import flatMap from 'lodash/flatMap';
import groupBy from 'lodash/groupBy';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { isMobileView } from '../../../ReactiveRender';
import * as React from 'react';
import './preview.css';
import RectangularBigBtn from '../../../../components2/Buttons/RectangularbigBtn';
import editIcon from '../../../../static/icons/edit_icon_purple_24.svg';
import closecircle from '../../../../static/img/closecircle.svg';

const PreviewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 12px 16px;
  border-bottom: 1px solid #c9c6cc80;
`;
const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const EditButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #7200E0;
  border-radius: 25px;
  cursor: pointer;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #7200E0;
  &:hover { background: #f2f1f380; }
`;
const CloseButton = styled.button`
  padding: 4px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover { opacity: 0.8; }
`;

export default function PreviewDialog({
  setMarkingCriteriaPreviewDialog,
  markingCriterias,
  showActionButton = false,
  onActionButtonClick = () => {},
  isSystem = false,
  showEditButton = true,
}) {
  const [open, setOpen] = React.useState(true);
  const history = useHistory();
  const onMobileView = isMobileView();
  const handleClose = () => {
    setOpen(false);
    setMarkingCriteriaPreviewDialog(false);
  };
  const handleEdit = () => {
    if (markingCriterias?.id) {
      const url = `/tools/rubrics/${markingCriterias.id}`;
      handleClose();
      history.push(url);
    }
  };
  const criteriaList = Array.isArray(markingCriterias?.criterias)
    ? markingCriterias.criterias
    : [];
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        sx={{ zIndex: 2147483647 }}
      >
        <PreviewHeader>
          <HeaderActions>
            {showEditButton && markingCriterias?.id && !isSystem && (
              <EditButton onClick={handleEdit} type="button">
                <img src={editIcon} alt="Edit" width={16} height={16} />
                <span>Edit</span>
              </EditButton>
            )}
            <CloseButton onClick={handleClose} type="button" aria-label="Close">
              <img src={closecircle} alt="Close" width={20} height={20} />
            </CloseButton>
          </HeaderActions>
        </PreviewHeader>
        <DialogContent>
          {criteriaList.length > 0 ? (
            <table className="rubrics-table">
              <thead>
                <tr className="title">
                  {createHeading(criteriaList)}
                </tr>
              </thead>
              <tbody>
                {createLevels(criteriaList)}
              </tbody>
            </table>
          ) : (
            <div className={`${onMobileView ? 'parent-container-sm' : 'parent-container'}`}>
              <div className="content">No rubric criteria to preview.</div>
            </div>
          )}
          {showActionButton && (
            <div className="action_button">
              <RectangularBigBtn
                text={'Import'}
                onClickFn={() => onActionButtonClick(markingCriterias)}
              />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
const createHeading = (criterias) => {
  return criterias?.map((criteria) => {
    return <td className="mc-title column-width">{criteria?.title}</td>;
  });
};

const createLevels = (criterias) => {
  // lodash/chain submodule lacks wrapper methods (flatMap/groupBy/map are
  // bound at the full lodash entry point only). Standalone helpers preserve
  // tree-shake savings without the chain-method-binding crash.
  const flattened = flatMap(criterias, (criteria, criteriaIndex) =>
    // Guard against a criterion with no (or non-array) levels (e.g. a malformed/variant-shaped
    // imported rubric) — a bad levels field must never whitescreen the whole app.
    (Array.isArray(criteria?.levels) ? criteria.levels : []).map((level, levelIndex) => ({
      criteriaIndex,
      levelIndex,
      title: criteria?.title,
      levelName: level?.name,
      levelDescription: level?.description,
    }))
  );
  const grouped = groupBy(flattened, 'levelIndex');
  let groupedArray = Object.entries(grouped).map(([name, items]) => ({ name, items }));

  return groupedArray.map((group) => {
    let rowItems = Array(criterias.length).fill(null);
    group.items.forEach((item) => {
      rowItems[item.criteriaIndex] = item;
    });
    return <tr className="data-parent">{createRows(rowItems)}</tr>;
  });
};

const createRows = (items) => {
  return items.map((item) => {
    if (item) {
      return (
        <td className="mk-column column-width">
          <div className="mk-heading">{item.levelName}</div>
          <div className="content">{item.levelDescription}</div>
        </td>
      );
    } else {
      return <td className="mk-empty-column column-width"></td>;
    }
  });
};
